import { render, staticRenderFns } from "./PatchForSidebar.vue?vue&type=template&id=0b865f1e&"
import script from "./PatchForSidebar.vue?vue&type=script&lang=js&"
export * from "./PatchForSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PatchForSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports